import { SVGProps } from "react"

const Checkbox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <rect
      width={14.875}
      height={14.875}
      x={0.563}
      y={0.563}
      stroke="#194F20"
      strokeWidth={0.875}
      rx={2.438}
    />
  </svg>
)
export default Checkbox
